/* eslint-disable react-hooks/exhaustive-deps */
import { Outlet } from "react-router-dom";
import { Box, Theme, ThemeProvider } from "@mui/material";
import DeliveryOffDialog from "@/pages/menu/components/DeliveryOffDialog";
import { useContext, useEffect, useMemo } from "react";
import { WebsiteContext } from "@/pages/website/WebsiteProvider";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import { useGetOrderByIdQuery } from "@/features/organizations/api/ordersApi";
import useOrder from "@/hooks/useOrder";

const MenuProvider = () => {
  const { organization, theme } = useContext(WebsiteContext);
  const { deleteLSOrganizationOrder, archiveOldOrders, getOrderInLocalStorage } = useOrder();

  const orderId = useMemo(() => {
    if (!organization?.id) return null;
    return getOrderInLocalStorage(organization.id);
  }, [organization?.id]);

  const { error } = useGetOrderByIdQuery(
    {
      organizationId: organization?.id ?? skipToken,
      orderId: orderId ?? skipToken,
    },
    {
      skip: !organization?.id || !orderId,
    }
  );
  // TODO: archive orders correctly if they are in local storage after 24hrs
  useEffect(() => {
    if (error?.status === 404) {
      deleteLSOrganizationOrder();
    } else {
      archiveOldOrders();
    }
  }, [error]);

  return (
    <ThemeProvider theme={theme as Theme}>
      <Box sx={{ height: "100%" }}>
        <Outlet />
        <DeliveryOffDialog />
      </Box>
    </ThemeProvider>
  );
};

export default MenuProvider;
